import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "prop-selector animated-fast" }
const _hoisted_2 = { class: "p-title" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "prop-hiearchy" }
const _hoisted_5 = {
  key: 0,
  style: {"display":"flex","justify-content":"center"}
}
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "p-hierarchy-top" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!
  const _component_imdex_radio = _resolveComponent("imdex-radio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(`ssa.displayPane.propSelector.title`)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_imdex_spinner, {
                size: "2",
                width: "50"
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableProps, (item, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  onClick: ($event: any) => (item.open = !item.open),
                  key: i,
                  class: "p-hierarchy-item"
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("i", {
                      style: {"width":"10px"},
                      class: _normalizeClass({
									'fa fa-caret-right': !item.open,
									'fa fa-caret-down': item.open
								})
                    }, null, 2),
                    _createTextVNode(" " + _toDisplayString(item.label), 1)
                  ]),
                  (item.open)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                        class: "p-hierarchy-children"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (child, c) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "p-hierarchy-child",
                            key: c
                          }, [
                            _createVNode(_component_imdex_radio, {
                              value: _ctx.selectedProp == null ? '' : _ctx.selectedProp.label,
                              onClick: ($event: any) => (_ctx.selectProp(child)),
                              val: child.label,
                              label: child.label
                            }, null, 8, ["value", "onClick", "val", "label"])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_7))
              }), 128))
            ]))
      ])
    ])
  ]))
}